import FraseConfirmacionActions from "./FraseConfirmacionActions";

const FraseConfirmacionRow = ({ frase, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{frase.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(frase.frase || "-"),
        }}
      />
      <td>{frase.orden || "-"}</td>
      <td>{frase.pregunta_texto || "-"}</td>
      <td>{frase.talento_nombre || "-"}</td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            frase.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {frase.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <FraseConfirmacionActions frase={frase} />
        </span>
      </td>
    </tr>
  );
};

export default FraseConfirmacionRow;
